"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ticketingCanGenerateReceipt = exports.canFormCategoryGenerateReceipt = exports.donationFormCanGenerateReceipt = exports.getTransactionReceiptCharityNumber = exports.getTransactionReceiptCharityNumberLabelKey = exports.shouldDisplayCharityNumberOnTransactionReceipt = exports.getReceiptNumber = exports.getReceiptPaperFormat = exports.isReceiptPostalCodeValid = exports.getReceiptTemplatePath = exports.isDonorAddressRequiredForReceipt = exports.isSignatureRequiredForGenerateReceipt = exports.canOrganizationGenerateReceipt = exports.getFakeReceiptRegion = exports.getFakeReceiptCity = exports.getFakeReceiptAddress = exports.isReceiptAllowFormCountry = exports.DEFAULT_ORGANIZATION_RECEIPT_COUNTRY = exports.RECEIPT_TABLE_CONSTRAINTS = exports.blockReceiptWithoutCityOrPostal = exports.isAddressFull = exports.hasOrganizationAdministrativeInformation = exports.getAustralianStateAbbreviation = exports.getActualYearBoundary = exports.requiresAnnualReceiptAnnex = exports.ANNUAL_RECEIPT_ANNEX_COUNTRIES = void 0;
const luxon_1 = require("luxon");
const enums_1 = require("../../enums");
const ticketing_1 = require("../../enums/ticketing");
const country_1 = require("../../helpers/country");
const country_2 = require("../enums/country");
const ein_1 = require("./ein");
const de_fiscal_1 = require("./de-fiscal");
const dates_1 = require("./dates");
exports.ANNUAL_RECEIPT_ANNEX_COUNTRIES = [country_2.OrganizationCountry.Germany];
const requiresAnnualReceiptAnnex = (country) => Boolean(country && exports.ANNUAL_RECEIPT_ANNEX_COUNTRIES.includes(country));
exports.requiresAnnualReceiptAnnex = requiresAnnualReceiptAnnex;
const getActualYearBoundary = ({ date, organizationCountry, timezone, }) => {
    if (organizationCountry === country_2.OrganizationCountry.Germany) {
        const localDate = luxon_1.DateTime.fromJSDate(date, { zone: timezone ?? undefined });
        if (!localDate.isValid) {
            return null;
        }
        return [localDate.startOf("year").toJSDate(), localDate.endOf("year").toJSDate()];
    }
    return (0, dates_1.getPendingReceiptYearBoundaries)({
        year: (0, dates_1.getPendingReceiptYearForDate)({ date, organizationCountry }),
        organizationCountry,
    });
};
exports.getActualYearBoundary = getActualYearBoundary;
const AUSTRALIAN_STATE_ABBREVIATIONS = ["ACT", "NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA"];
const getAustralianStateAbbreviation = (region) => {
    if (!region) {
        return undefined;
    }
    const trimmed = region.trim().toUpperCase();
    if (AUSTRALIAN_STATE_ABBREVIATIONS.includes(trimmed)) {
        return trimmed;
    }
    return (0, country_1.getRegionShortCodeFromCountryAndRegionName)(country_2.CountryNames.Australia, region.trim()) ?? region;
};
exports.getAustralianStateAbbreviation = getAustralianStateAbbreviation;
const hasOrganizationAdministrativeInformation = ({ address, city, postalCode, region, }) => {
    return Boolean(address && city && postalCode && region);
};
exports.hasOrganizationAdministrativeInformation = hasOrganizationAdministrativeInformation;
const isAddressFull = (country, command) => {
    if (country === country_2.OrganizationCountry.UnitedStates) {
        return Boolean(command?.country);
    }
    return Boolean(command?.address && command?.postalCode && command.city && command.country);
};
exports.isAddressFull = isAddressFull;
const blockReceiptWithoutCityOrPostal = (country) => {
    return (country === country_2.OrganizationCountry.Canada ||
        country === country_2.OrganizationCountry.Australia ||
        country === country_2.OrganizationCountry.Germany);
};
exports.blockReceiptWithoutCityOrPostal = blockReceiptWithoutCityOrPostal;
exports.RECEIPT_TABLE_CONSTRAINTS = {
    CITY_NOT_NULL: `organization_country <> '${country_2.OrganizationCountry.Canada}' OR city IS NOT NULL`,
    POSTAL_CODE_NOT_NULL: `organization_country <> '${country_2.OrganizationCountry.Canada}' OR postal_code IS NOT NULL`,
    AUSTRALIA_CITY_NOT_NULL: `organization_country <> '${country_2.OrganizationCountry.Australia}' OR city IS NOT NULL`,
    AUSTRALIA_POSTAL_CODE_NOT_NULL: `organization_country <> '${country_2.OrganizationCountry.Australia}' OR postal_code IS NOT NULL`,
};
exports.DEFAULT_ORGANIZATION_RECEIPT_COUNTRY = country_2.OrganizationCountry.Canada;
const isReceiptAllowFormCountry = (country) => {
    return Boolean(country && country !== country_2.OrganizationCountry.GreatBritain && country !== country_2.OrganizationCountry.Ireland);
};
exports.isReceiptAllowFormCountry = isReceiptAllowFormCountry;
const getFakeReceiptAddress = (country) => {
    if (country === country_2.OrganizationCountry.Canada) {
        return "Nonprofit's full address / Adresse de l'organisme";
    }
    return "Nonprofit's full address";
};
exports.getFakeReceiptAddress = getFakeReceiptAddress;
const getFakeReceiptCity = (country) => {
    if (country === country_2.OrganizationCountry.Canada) {
        return "Montréal";
    }
    if (country === country_2.OrganizationCountry.Australia) {
        return "Sydney";
    }
    if (country === country_2.OrganizationCountry.GreatBritain) {
        return "London";
    }
    if (country === country_2.OrganizationCountry.Germany) {
        return "Berlin";
    }
    return "New York";
};
exports.getFakeReceiptCity = getFakeReceiptCity;
const getFakeReceiptRegion = (country) => {
    if (country === country_2.OrganizationCountry.Canada) {
        return "Québec";
    }
    if (country === country_2.OrganizationCountry.Australia) {
        return "NSW";
    }
    if (country === country_2.OrganizationCountry.GreatBritain) {
        return "London";
    }
    if (country === country_2.OrganizationCountry.Germany) {
        return "Berlin";
    }
    return "New York";
};
exports.getFakeReceiptRegion = getFakeReceiptRegion;
const canOrganizationGenerateReceipt = ({ country, hasAdministrativeInformation, hasCharityNumber, hasDeReceiptFields, deLegalForm, signatureUrl, type, }) => {
    if (type !== enums_1.OrganizationType.Charity && type !== enums_1.OrganizationType.Other501C) {
        return false;
    }
    if (country === country_2.OrganizationCountry.GreatBritain || country === country_2.OrganizationCountry.Ireland) {
        return false;
    }
    else if (country === country_2.OrganizationCountry.Canada) {
        return hasAdministrativeInformation && hasCharityNumber && Boolean(signatureUrl);
    }
    else if (country === country_2.OrganizationCountry.UnitedStates) {
        return hasAdministrativeInformation && hasCharityNumber;
    }
    else if (country === country_2.OrganizationCountry.Australia) {
        return hasAdministrativeInformation && hasCharityNumber;
    }
    else if (country === country_2.OrganizationCountry.Germany) {
        return (hasAdministrativeInformation &&
            hasCharityNumber &&
            hasDeReceiptFields &&
            (0, de_fiscal_1.isDeLegalFormEligibleForReceipt)(deLegalForm) &&
            Boolean(signatureUrl));
    }
    return false;
};
exports.canOrganizationGenerateReceipt = canOrganizationGenerateReceipt;
const isSignatureRequiredForGenerateReceipt = (country) => {
    return country === country_2.OrganizationCountry.Canada || country === country_2.OrganizationCountry.Germany;
};
exports.isSignatureRequiredForGenerateReceipt = isSignatureRequiredForGenerateReceipt;
const isDonorAddressRequiredForReceipt = (country) => {
    return (country === country_2.OrganizationCountry.Canada ||
        country === country_2.OrganizationCountry.Australia ||
        country === country_2.OrganizationCountry.Germany);
};
exports.isDonorAddressRequiredForReceipt = isDonorAddressRequiredForReceipt;
const getReceiptTemplatePath = (country, isAnnualReceipt = false) => {
    if (country === country_2.OrganizationCountry.Australia) {
        return "receipt/australiaV2.hbs";
    }
    if (country === country_2.OrganizationCountry.Canada) {
        return "receipt/canadaV2.hbs";
    }
    if (country === country_2.OrganizationCountry.UnitedStates) {
        return "receipt/unitedstatesV2.hbs";
    }
    if (country === country_2.OrganizationCountry.Germany) {
        return isAnnualReceipt ? "receipt/germanyAnnualV2.hbs" : "receipt/germanyV2.hbs";
    }
    throw new Error(`Receipt template path not found for country: ${country}`);
};
exports.getReceiptTemplatePath = getReceiptTemplatePath;
const isReceiptPostalCodeValid = (country, postalCode) => {
    if (country !== country_2.OrganizationCountry.Germany) {
        return true;
    }
    return (0, de_fiscal_1.isDePostalCodeValid)(postalCode);
};
exports.isReceiptPostalCodeValid = isReceiptPostalCodeValid;
const getReceiptPaperFormat = (country) => {
    return country === country_2.OrganizationCountry.Germany ? "a4" : "letter";
};
exports.getReceiptPaperFormat = getReceiptPaperFormat;
const getReceiptNumber = (country, { organizationNumber, sequentialNumber, charityNumber, }) => {
    // Australia format: [ABN_LAST4]-[YYYY]-[SEQUENTIAL_7]
    if (country === country_2.OrganizationCountry.Australia) {
        const abnLast4 = charityNumber?.slice(-4) || "0000";
        const currentYear = new Date().getFullYear();
        return `${abnLast4}-${currentYear}-${sequentialNumber}`;
    }
    return "SI2-" + organizationNumber + "-" + sequentialNumber + "";
};
exports.getReceiptNumber = getReceiptNumber;
const shouldDisplayCharityNumberOnTransactionReceipt = ({ charityNumber, deTaxNumber, hasGiftAidConfirmation, organizationCountry, }) => {
    if (organizationCountry === country_2.OrganizationCountry.Germany) {
        return Boolean(deTaxNumber);
    }
    return Boolean(charityNumber && (hasGiftAidConfirmation || organizationCountry === country_2.OrganizationCountry.Australia));
};
exports.shouldDisplayCharityNumberOnTransactionReceipt = shouldDisplayCharityNumberOnTransactionReceipt;
const getTransactionReceiptCharityNumberLabelKey = ({ organizationCountry, }) => {
    if (organizationCountry === country_2.OrganizationCountry.Australia) {
        return "notification.transactionReceipt.charityNumberLabel.australia";
    }
    if (organizationCountry === country_2.OrganizationCountry.Germany) {
        return "notification.transactionReceipt.charityNumberLabel.germany";
    }
    return "notification.transactionReceipt.charityNumberLabel.default";
};
exports.getTransactionReceiptCharityNumberLabelKey = getTransactionReceiptCharityNumberLabelKey;
const getTransactionReceiptCharityNumber = ({ charityNumber, deTaxNumber, organizationCountry, }) => {
    if (organizationCountry === country_2.OrganizationCountry.Germany) {
        return deTaxNumber ?? undefined;
    }
    return (0, ein_1.formatCharityNumberForDisplay)(organizationCountry, charityNumber) ?? undefined;
};
exports.getTransactionReceiptCharityNumber = getTransactionReceiptCharityNumber;
const donationFormCanGenerateReceipt = (donationForm, organization) => organization.canGenerateReceipt && donationForm.hasReceipt;
exports.donationFormCanGenerateReceipt = donationFormCanGenerateReceipt;
const canFormCategoryGenerateReceipt = (country, formCategory) => !(country === country_2.OrganizationCountry.Germany && formCategory === ticketing_1.TicketingFormCategory.MembershipV2);
exports.canFormCategoryGenerateReceipt = canFormCategoryGenerateReceipt;
const ticketingCanGenerateReceipt = (ticketing, rates, organization) => {
    if (!(0, exports.canFormCategoryGenerateReceipt)(organization.country, ticketing.formCategory)) {
        return false;
    }
    const formCanGenerateReceipt = (ticketing.extraDonation && ticketing.generateExtraDonationReceipt) ||
        rates.some((rate) => Boolean(rate.eligibleAmount));
    return organization.canGenerateReceipt && formCanGenerateReceipt;
};
exports.ticketingCanGenerateReceipt = ticketingCanGenerateReceipt;
